function errorData (error) {
  const data = error && error.response && error.response.data
  return data && typeof data === 'object' ? data : error
}

function requestIdFrom (error, data) {
  return (data && (data.support_code || data.request_id || data.requestId)) ||
    (error && (error.support_code || error.request_id || error.requestId)) ||
    (error && error.correlation && error.correlation.requestId)
}

function statusFrom (error, data) {
  return (data && (data.http_status || data.status)) ||
    (error && (error.httpStatus || error.status)) ||
    (error && error.response && error.response.status)
}

function outcomeUnknownFrom (error, data) {
  return Boolean(
    (data && data.outcome_unknown) ||
    (error && (error.outcomeUnknown || error.outcome_unknown))
  )
}

function appendSupportCode (message, requestId) {
  if (!requestId || (message && message.includes(requestId))) return message
  return `${message} Código de atendimento: ${requestId}`
}

export function getUserErrorMessage (error, fallback = 'Não foi possível concluir a solicitação.') {
  const data = errorData(error)
  const requestId = requestIdFrom(error, data)
  const status = Number(statusFrom(error, data))
  const outcomeUnknown = outcomeUnknownFrom(error, data)

  if (outcomeUnknown) {
    const message = data && data.user_message ? data.user_message : fallback
    return appendSupportCode(message, requestId)
  }

  if (status >= 500) {
    return appendSupportCode(fallback, requestId)
  }

  if (data && typeof data.message === 'string' && data.message.trim()) {
    return data.message
  }

  return fallback
}
